// src/CreatePostModal.js
// Окно «Создать пост» для кнопки в ленте. В админ-панели та же форма
// встроена в страницу, а на главной её нужно поднять над лентой.

import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PostForm from './PostForm';
import './PostCompose.css';

export default function CreatePostModal({ initialSection, initialSubcategory, onClose, onCreated }) {
  // Пока окно открыто, лента под ним не прокручивается
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  // Через портал в body: у ленты и карточек есть анимации с transform,
  // а такой предок сбивает position: fixed (так же сделан FilePreview).
  // Клик мимо окна и Escape его намеренно не закрывают — иначе набранный
  // текст теряется одним случайным движением; закрыть можно × и «Отмена».
  return createPortal(
    <div className="post-compose" role="dialog" aria-modal="true" aria-label="Создание поста">
      <div className="post-compose-dialog">
        <PostForm
          initialSection={initialSection}
          initialSubcategory={initialSubcategory}
          onCancel={onClose}
          onSaved={onCreated}
        />
      </div>
    </div>,
    document.body
  );
}
